import { render, staticRenderFns } from "./AccountPositionList.vue?vue&type=template&id=064d87bc&scoped=true&"
import script from "./AccountPositionList.vue?vue&type=script&lang=js&"
export * from "./AccountPositionList.vue?vue&type=script&lang=js&"
import style0 from "./AccountPositionList.vue?vue&type=style&index=0&id=064d87bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.2_css-loader@6.8.1_prettier@3.0.3_vue-template-compiler@2.6.14_webpack@5.88.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064d87bc",
  null
  
)

export default component.exports